module.exports = __webpack_public_path__ + "media/images/arrow-right-gold-0ed4fb7b39e704e05805bf673d95223f.svg";